import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

export function getFormGroup(): UntypedFormGroup {
  return new UntypedFormBuilder().group({
    user: [null]
  });
}
